import { render } from "./RiskAnalysisPage.vue?vue&type=template&id=92319d68&scoped=true"
import script from "./RiskAnalysisPage.vue?vue&type=script&lang=js"
export * from "./RiskAnalysisPage.vue?vue&type=script&lang=js"

import "./RiskAnalysisPage.vue?vue&type=style&index=0&id=92319d68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92319d68"]])

export default __exports__